import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import * as echarts from 'echarts'
import { Loading, Message, Divider, Descriptions, DescriptionsItem, Button } from 'element-ui'
import i18n from './i18n'
import dayjs from 'dayjs'
import qs from 'qs'

import '@/icons' // icon

import * as filters from './filters' // global filters

// dayjs支持的语言: https://cdn.jsdelivr.net/npm/dayjs@1/locale.json
import pl from 'dayjs/locale/pl' // Polish
import it from 'dayjs/locale/it' // 意大利语
import bg from 'dayjs/locale/bg' // 保加利亚语
import sk from 'dayjs/locale/sk' // 斯洛伐克语
import hr from 'dayjs/locale/hr' // 克罗地亚语
import de from 'dayjs/locale/de' // 德语
import cs from 'dayjs/locale/cs' // 捷克语
import sl from 'dayjs/locale/sl' // 斯洛文尼亚
import sv from 'dayjs/locale/sv' // 瑞典语
import el from 'dayjs/locale/el' // 希腊语
import es from 'dayjs/locale/es' // 西班牙语
import ru from 'dayjs/locale/ru' // 俄罗斯语
import hu from 'dayjs/locale/hu' // 西班牙语
import locale_zh from 'dayjs/locale/zh'
// import locale_zh_tw from 'dayjs/locale/zh-tw'
// dayjs.locale(pl) // dayjs默认支持英语 ; 预计切换放到下面差不多20行的位置(即从location里头取search里头的参数)

import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)

// 从url里头取时区参数
let query = {}
if (location && location.search) {
  const s = location.search
  if (/\?/.test(s)) {
    query = qs.parse(s.split('?')[1])
  }
}
window._query = query
if (query) { // 这里头还只是dayjs的一些设置；报告的语言、时区等的切换逻辑，放到Bg.vue或者Pump.vue等相应报告逻辑里头
  if (query.lang) {
    // 设置语言
    const lang = `${query.lang}`
    /* eslint-disable */    
    switch (lang.toLowerCase()) {
    case `pl`:
    case `polish`:
      dayjs.locale(pl)
      break
    case `it`:
      dayjs.locale(it)
      break
    case `bg`:
      dayjs.locale(bg)
      break
    case `sk`:
      dayjs.locale(sk)
      break
    case `hr`:
      dayjs.locale(hr)
      break
    case `de`:
      dayjs.locale(de)
      break
    case `cs`:
      dayjs.locale(cs)
      break
    case `sl`:
      dayjs.locale(sl)
      break
    case `sv`:
      dayjs.locale(sv)
      break
    case `el`: // dayjs 里头是el;但pancares里头公司内部说是gr
      dayjs.locale(el)
      break
    case `es`:
      dayjs.locale(es)
      break
    case `ru`:
      dayjs.locale(ru)
    case `hu`:
      dayjs.locale(hu)
      break
    case `zh`:
    case `Zh`:
      dayjs.locale(locale_zh)
      break
    }
    /* eslint-enable */
  }
  if (query.tz) {
    // 设置时区
    dayjs.tz.setDefault(query.tz)
  }

  // 获取startOfWeek是周一还是周日参数
  try {
    const s = dayjs().startOf('week').day()
    window._startOfWeek = s
  } catch (error) {
    console.error('被捕获:' + error)
  }
}

import localeData from 'dayjs/plugin/localeData' // https://day.js.org/docs/en/plugin/locale-data
dayjs.extend(localeData)
// 为了weekday(0)函数返回的本地化的一周的第一天
import weekday from 'dayjs/plugin/weekday' // https://day.js.org/docs/en/plugin/weekday
dayjs.extend(weekday)
// import isoWeek from 'dayjs/plugin/isoWeek' // var isoWeek = require() // https://day.js.org/docs/en/plugin/iso-week
// dayjs.extend(isoWeek)

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.use(Loading)
Vue.use(Divider)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Button)
Vue.prototype.$message = Message
Vue.prototype.$loading = Loading.service

// window.i18n = i18n
const _i18nMissing = []
i18n._missing = (lang, miss) => {
  // 异步推入
  _i18nMissing.push(miss)
}
window._i18nMissing = _i18nMissing
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
